import * as React from "react";

import { getProductName } from "../configuration";
import ErrorBoundary from "./ErrorBoundary";
import { IPageDefinition } from "./PageDefinitionTypes";

import { announce } from "azure-devops-ui/Core/Util/Accessibility";
import { css } from "azure-devops-ui/Util";

interface IPage {
    page: IPageDefinition;
    key: number | string;
    routeOverride?: string;
}

class Page extends React.Component<IPage> {
    public render() {
        return (
            <div className={css(this.props.page.containerClassName, "flex-grow")}>
                <ErrorBoundary>
                    {React.createElement(
                        typeof this.props.page.component === "object" ? this.props.page.component.default : this.props.page.component,
                        {}
                    )}
                </ErrorBoundary>
            </div>
        );
    }

    public componentDidMount() {
        // React router doesn't trigger navigation so we will need to set the document title and announce when the page has loaded.
        announce(`Loaded ${this.props.page.name} page`);
    }

    public componentWillMount() {
        document.title = this.props.page.name + " - " + getProductName();
    }
}

export default Page;
